import {CostDistributionType} from "./CostDistributionType";
import {Cloneable} from "../../../model/common.model";

export class CostDistributionConfig   extends Cloneable{


  id: number;
  costDistributionType = CostDistributionType.SI_COST_TYPE
  value: string;
  description: string;


  _createSpecialElement(propertyName: string, data: any) {
    if ('costDistributionType' === propertyName) {
      this.costDistributionType = CostDistributionType.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  public get display():string{
    let res = this.value;
    if (this.description && this.description.trim().length>0){
      res += ' - ' + this.description;
    }
    return res;
  }

  public get displayShort():string{
    let res = this.value;
    if (this.description && this.description.trim().length>0){
      res += ' - ' + this.description.trim().substring(0,5);
    }
    return res;
  }


}
